export class UsersEntity {
    user_id: number = 0;
    email: String = "";
    password: string = "";
    gender: String = "";
    is_bayi: number = 0;
    is_person: string = "";
    tc_kimlik_no: number = 0;
    lastname: String = "";
    name: String = "";
    sso_user_id: String = "";
    musteri_no: any = null ;
    user_permission_type_id: number = 1;
    created_at: string | null = null;
}